import { CorsComponent } from '@weapp/ui';
import { eventEmitter } from '@weapp/utils';
import React, { PureComponent } from 'react';
import { Route, RouteComponentProps, withRouter } from 'react-router-dom';
import { TerminalType } from '../../common/types';
import { BaseProps } from '../../components/page-view/types';
import { FixedMenu, MultiFill, PageModuleType } from '../../constants';
import { fomatParentPath } from '../../utils';
import ebdcoms from '../../utils/ebdcoms';
import { LOG } from '../../utils/log';
import {
  getApp, getCompName, getCorsProps, MenuInfo,
} from '../../utils/page';
import multiRoutePageStore from '../multi-page/Store';
import { LinkInfo } from '../types';
import routeUtils from '../utils';
import { getFixedMenuAppId } from './utils';

const getClientType = (clientType: TerminalType, url: string) => {
  let client = clientType || 'PC';

  // 页面预览
  if (!url.includes('/preview/')) {
    client = url.includes('mobile') || clientType === 'MOBILE' ? 'MOBILE' : 'PC';
  }

  return client;
};

const isAppSpaRuntime = (url: string) => url.match(/(sp|mobile)\/ebdapp/);

// 判断是否是构建页面
const isBuildPage = (url: string) => url.match(/sp\/ebdapp\/build/);

interface RoutePageProps extends BaseProps {
  customRenderRight?: any; // 应用运行时特殊处理头部右侧按钮
  mobileView?: boolean; // 移动端应用运行特殊处理报表
  showGroup?: boolean; // 运行页面是否展示分组
  runType?: string;
  menuInfo?: MenuInfo;
  /** 是否启用多页面机制，默认开启 */
  enabledMultiPage?: boolean;
  isPreview?: boolean; // 是否预览页面
  // 指定某个页面类型
  pageType?: string;
  // 指定某个页面id
  pageId?: string;
  appId?: string; // 应用id
  refreshMenus?: () => void; // 刷新ebdapp预览和运行侧边栏方法
  // 是否排除设置菜单类型
  excludeSetting?: boolean;
  // 是否从主路由入口进入
  isRouteMain?: boolean;
  // 返回当前是否匹配到路由页面内容
  onMatchRoutePage?: (hasMatchRoutePage: boolean) => void;
  // 删除单页面全局loading
  destroyGlobalLoading?: () => void;
}

class RoutePage extends PureComponent<
  RoutePageProps & RouteComponentProps<{ type: string; id: string }>
> {
  getPageInfo() {
    const {
      match,
      menuInfo,
      pageType: _imputPageType,
      pageId: _imputpageId,
      excludeSetting,
      isRouteMain,
    } = this.props;

    let { pathname } = this.props.location;

    const { type, id: _id } = match.params;
    const id = routeUtils.formatterPageId(_id);
    const { PageType, getUrlParams } = ebdcoms.get();
    let appid = '';
    let _pageId = _imputpageId || id || '';
    let _type = _imputPageType || type || '';
    let key = id;
    let isUnitFill = '';
    // 获取type和id前的路径不再判断
    const parentMatchPath = match.path.substring(0, match.path.indexOf('/:'));
    const replaceReg = new RegExp(`^${parentMatchPath}`);
    pathname = pathname.replace(replaceReg, '');
    if (isRouteMain) {
      pathname = pathname.replace(/.*(\/ebdpage\/view\/.*)/, (...args) => args?.[1]) || pathname;
    }

    if (!pathname.includes('dlg/')) {
      const [_pageInfoType, _pageInfoId] = routeUtils.getPageInfo(pathname, excludeSetting);
      _type = _pageInfoType || _type;
      _pageId = _pageInfoId || _pageId;
    }

    // appid 从pageId参数里面取, 流程pageId 路由参数格式 ${appid}_${pageId}
    if ([PageType.Workflow, PageType?.Combinate?.toUpperCase()].includes(_type.toUpperCase())) {
      [appid, _pageId, isUnitFill] = _pageId?.split('_');
    }

    if (_pageId?.includes('-')) {
      [_pageId, key] = _pageId?.split('-');
    }

    if (
      _type.toUpperCase() === FixedMenu.Base
      || _type.toUpperCase() === FixedMenu.Setting
      || _type.toUpperCase() === MultiFill.MultireportMonitor
      || _type.toUpperCase() === MultiFill.MultireportTask
    ) {
      appid = getFixedMenuAppId(_type, this.props.location?.pathname);
      key += _type;
    }
    key += menuInfo?.searchId || '';
    _pageId = _imputpageId || _pageId;
    _type = _imputPageType || _type;

    // 从主路由进入的页面,如果没有type、pageId,默认展示页面类型
    if (isRouteMain && !routeUtils.getPageInfo(pathname, excludeSetting)[1]) {
      _pageId = this.props.location.pathname?.split('/ebdpage/view/')?.pop()?.split('/')?.[0] || '';
      _type = PageType.Page;
    }

    // 针对EB表单高级视图独立部署场景的处理
    if (_type.toUpperCase() === PageType.ViewPort && !appid) {
      const appIdRegExp = new RegExp(`(\\d+)_${_pageId}$`);
      const [, pathAppId] = pathname.match(appIdRegExp) || [];
      if (pathAppId) {
        appid = pathAppId;
      }
    }

    return {
      appid,
      key,
      pageId: _pageId,
      type: _type,
      urlParams: getUrlParams(_pageId),
      isUnitFill,
    };
  }

  renderComponent = () => {
    const {
      type: pageType,
      match,
      location: { pathname },
      clientType = 'PC',
      customRenderRight,
      mobileView,
      showGroup,
      runType,
      menuInfo,
      history,
      enabledMultiPage = false,
      isPreview = false,
      servicePath,
      appId = '',
      onPageChange,
      refreshMenus,
      noSetTitle,
      onMatchRoutePage,
    } = this.props;

    // 针对表单单页路由跳转情况以及门户页面
    if (pageType === PageModuleType.Portal) {
      onMatchRoutePage?.(false);

      return null;
    }
    const { PageType } = ebdcoms.get();

    // 在已有的路由history内切换，如点击浏览器的前进后退，都属于POP
    const isHistoryPop = history.action === 'POP';
    const client = getClientType(clientType, match.url);
    const {
      appid, pageId, type, key, urlParams, isUnitFill,
    } = this.getPageInfo();
    let app = getApp(type, pageId, pathname, appid);
    let compName = getCompName(type, pageId, client, pathname) || '';

    // 业务组件的调用信息存放在 location 上，根据配置动态调用
    if (type.toUpperCase() === PageType.BussComp) {
      const page = (history.location.state as LinkInfo)?.page;
      const curPageInfo = page || menuInfo;
      app = client === 'MOBILE' ? curPageInfo?.mobileModule || '' : curPageInfo?.module || '';
      compName = client === 'MOBILE' ? curPageInfo?.mobileCompName || '' : curPageInfo?.compName || '';
    }

    if (!app || !compName) {
      onMatchRoutePage?.(false);

      return null;
    }

    this.destroyGlobalLoading(app, compName);

    onMatchRoutePage?.(true);

    const corsParams = {
      type,
      pageId,
      appId: appid || appId,
      customRenderRight,
      mobileView,
      urlParams,
      showGroup,
      menuInfo,
      clientType: client,
      pathname,
      isUnitFill: isUnitFill === '1',
      match,
      location,
      history,
      noSetTitle,
    };

    const corsProps: any = getCorsProps(corsParams);
    const detailId = corsProps?.comParams?.id || urlParams?.id || '';
    const { has, isActived, setAppid } = multiRoutePageStore;
    // 相同菜单下页面但数据不同时，加上数据id
    const multiPageData = { id: `${pageId}-${key}-${detailId}`, type };
    const isExistPage = has(multiPageData);

    // 选中页面更新
    onPageChange?.(pageId);
    setAppid(appId || 'defaultAppid');

    eventEmitter.emit('@weapp/ebdpage', 'change.activePage', pageId);
    // 记录日志便于后期定位，日志含义：ebdpage路由页面开始渲染对应的页面类型组件
    LOG?.set({
      logType: 'ebdpage-route-page-renderComponent',
      data: {
        compName,
        app,
        corsProps,
      },
    });

    // 1. 页面单页运行不启用多页面机制
    // 2. 门户运行同时使用了PageView和RoutePageView会导致产生两个页面, 不启用
    // 3. 主框架下左侧菜单选中，右侧内容会重新渲染，导致多页面机制失效，并会导致缓存的多页面重复渲染，不启用
    // 4. 设置菜单下的页面切换, 设置组件会重新渲染，不启用
    if (
      !enabledMultiPage
      || isBuildPage(match.url)
      || !isAppSpaRuntime(match.url)
      // PC端禁用逻辑多页面机制
      || clientType !== 'MOBILE'
    ) {
      return (
        <CorsComponent
          weId={`${this.props.weId || ''}_ah4987`}
          app={app}
          key={key}
          compName={compName}
          mount={this.props.mount}
          runType={runType}
          isPreview={isPreview}
          servicePath={servicePath}
          {...corsProps}
        />
      );
    }

    /**
     * 多页面路由逻辑
     * 1. 路由跳转时页面需要重新渲染
     * 2. 路由pop时，显示已缓存的页面
     * 3. 多级填报页面pageId相同，但type不同，相互切换不生效，故特殊处理
     * 4. 相同菜单设置不同参数，pageId相同但key不同，故id有pageId改为`${pageId}-${key}`
     */
    if (!isExistPage || (!isActived(multiPageData) && !isHistoryPop)) {
      // 记录上次菜单页面内容
      const actName = !isExistPage ? 'push' : 'replace';

      const pageKey = `${pageId}-${key}-${detailId}`;

      if (actName === 'replace') {
        multiRoutePageStore.resetRandomKey(pageKey);
      }

      multiRoutePageStore[actName]({
        id: pageKey,
        type,
        node: (
          <CorsComponent
            weId={`${this.props.weId || ''}_ah4987`}
            app={app}
            key={`${key}_${multiRoutePageStore.getRandomKey(pageKey)}`}
            compName={compName}
            mount={this.props.mount}
            runType={runType}
            isPreview={isPreview}
            refreshMenus={refreshMenus}
            multiPageData={multiPageData}
            {...corsProps}
          />
        ),
      });
    }

    multiRoutePageStore.setActivePage(multiPageData);

    return null;
  };

  destroyGlobalLoading = (app: string, compName: string) => {
    if (
      this.props.destroyGlobalLoading
      && (app !== '@weapp/ebdpage' || !['PageView', 'MPageView'].includes(compName))
    ) {
      this.props.destroyGlobalLoading();
    }
  };

  getPagePath = () => {
    const parentPath = fomatParentPath(this.props);
    const matchUrl = this.props.match?.url;
    const pathname = this.props.location?.pathname;
    const moduleUrl = pathname.slice(matchUrl.length);
    // app预览时跳转流程页面，流程页面的功能依赖于匹配的parentPath
    // 导航到流程模块的组件parentPath需要带上流程模块的路由
    // id === 'cusapp_combination'的场景路由匹配到cusapp_combination为止
    if (/^\/workflow\/\d+_todo/.test(moduleUrl)) {
      return `${parentPath}/:type?/:id?`;
    }
    return parentPath;
  };

  render() {
    const path = this.getPagePath();
    // 记录日志便于后期定位，日志含义：ebdpage路由页面开始渲染
    LOG?.set({ logType: 'ebdpage-route-page-render' });
    return (
      <Route weId={`${this.props.weId || ''}_b7df88`} path={path} render={this.renderComponent} />
    );
  }
}

export default withRouter(RoutePage);
